import Show from '../Show/Show';
import { COLORS } from '../../config/designSystem/Colors';
import { DimensionValue, StyleSheet, TouchableOpacity, View } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { Subtitle1 } from '../../config/designSystem/typography';
import { isWeb } from '../../config/designSystem/Layout';
import { observer } from 'mobx-react';

const SIZE_ICON = 48;
const PADDING = 10;

const styles = StyleSheet.create({
  button: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: COLORS.surface.contrast,
    height: SIZE_ICON,
    width: SIZE_ICON,
    borderRadius: SIZE_ICON / 2,
    shadowColor: COLORS.brand[10],
    shadowRadius: 8,
    shadowOffset: { width: -2, height: -2 },
    shadowOpacity: 1
  },
  buttonWeb: {
    padding: PADDING,
  },
  buttonDisabled: {
    display: 'none',
  }
});

const BackButton = ({onPress = () => {return;}, disabled = false}) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[
        styles.button,
        isWeb && styles.buttonWeb,
        disabled && styles.buttonDisabled,
      ]}
      disabled={disabled}
    >
      <Feather name="chevron-left" size={SIZE_ICON/2} color={COLORS.border.accent} />
    </TouchableOpacity>
  );
};

const ExitButton = ({onPress = () => {return;}}) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[
        styles.button,
        isWeb && styles.buttonWeb,
      ]}
    >
      <Feather name="x" size={SIZE_ICON/2} color={COLORS.border.accent} />
    </TouchableOpacity>
  );
};

export const MARGIN_ACTION_BAR = 16;

interface ActionBarProps {
  width?: DimensionValue,
  height: number;
  isPreviousAvailable?: boolean
  onPrevious?: () => void;
  onExit?: () => void;
  title?: string;
  hideExit?:boolean;
  marginTopPhone?: number;
  backButtonDisabled?: boolean;
}
const ActionBar = observer(({
  width,
  height,
  onPrevious,
  onExit,
  title,
  hideExit,
  marginTopPhone,
  backButtonDisabled,
}: ActionBarProps) => {
  // FIXME should the title be visible on all screens or only Asssistance surveys ?
  return (
    <View
      style={[{
        width,
        height,
        margin: MARGIN_ACTION_BAR,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex:1

      }, (!isWeb && !!marginTopPhone) && {marginTop: marginTopPhone}
      ]}
    >
      <View style={{width: SIZE_ICON}}>
        <BackButton onPress={onPrevious} disabled={backButtonDisabled} />
      </View>
      <View style={{alignItems: 'center', justifyContent: 'center',zIndex: 10, flex: 1, paddingHorizontal: 8}}>
        <Subtitle1 color={COLORS.content.primary} align={true} numberOfLines={1}>
          {title}
        </Subtitle1>
      </View>
      <View style={{width: SIZE_ICON}}>
        <Show when={!hideExit}>
          <ExitButton onPress={onExit} />
        </Show>
      </View>

    </View>
  );
});
export default ActionBar;
